import { useLocation } from "react-router-dom";
import { Construction, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import PrivateLayout from "@/components/layout/auth/PrivateLayout";
import { useI18n } from "@/hooks/useI18n";

const WorkingProgress = () => {
  const { t } = useI18n();
  const location = useLocation();
  
  // Estrai il nome della pagina dall'URL
  const pageName = location.pathname.split('/')[1] || 'page';
  const capitalizedPageName = pageName.charAt(0).toUpperCase() + pageName.slice(1);

  return (
    <PrivateLayout 
      pageTitle={capitalizedPageName}
      pageDescription={t('common.comingSoon')}
    >
      <div className="max-w-md w-full mx-auto text-center p-8">
        <div className="mb-8">
          <Construction className="h-24 w-24 text-orange-500 mx-auto mb-4" />
          <h1 className="text-gray-900 mb-2">
            {capitalizedPageName}
          </h1>
          <p className="text-lg text-gray-600 mb-6">
            {t('common.comingSoon')}
          </p>
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
            <p className="text-orange-800">
              {t('common.workingOnFeature')}
            </p>
          </div>
        </div>
        
        <div className="space-y-4">
          <Button asChild className="w-full">
            <Link to="/dashboard">
              <ArrowLeft className="h-4 w-4 mr-2" />
              {t('common.backToDashboard')}
            </Link>
          </Button>
        </div>
      </div>
    </PrivateLayout>
  );
};

export default WorkingProgress;
